module.exports = __webpack_public_path__ + "assets/img/1.bc2effd8.png";